import { arrayOf, shape, number, string } from 'prop-types';

export default arrayOf(
  shape({
    id: number.isRequired,
    displayName: string.isRequired,
  })
);
